import React from "react";
import { CREDIT_NOTE_STATUS } from "../apiContract";

export default function CreditNoteStatusBadge({ status }) {
  const s = String(status || "").trim().toLowerCase();
  const isOpen = s === CREDIT_NOTE_STATUS.OPEN;
  return (
    <span
      className={`badge ${isOpen ? "text-bg-success" : "text-bg-secondary"}`}
    >
      {isOpen ? "Open" : "Closed"}
    </span>
  );
}
